import { odata } from '../../conf';
import Actions from '../../odata/actions';
import { useAuth } from '../../../use';

const auth = useAuth();

const actions = new Actions('account', 'accounts');

const customActions = {
  async UPDATE_account({ commit, state, rootGetters }, data) {
    const token = await auth.getAccessToken();
    await odata.o(rootGetters, token)
      .patch(`accounts(${data.accountID})`, data)
      .query();
    const items = state.accounts;
    if (items?.length > 0) {
      const updatedItem = items.find((l) => l.id === data.accountID);
      if (updatedItem) {
        Object.assign(updatedItem, data);
        commit('SET_accounts', items);
      }
    }
    return data;
  },
};

export default { ...actions, ...customActions };
